@if (vibrationRecord() !== undefined) {
  <div class="vib-chart">

    <div class="vib-chart__tabs">
      @for (tab of tabs; track tab.key) {
        <app-button class="vib-chart__tab"
          [class.vib-chart__tab--active]="selectedTab() === tab.key"
          variant="tertiary" size="small"
          [label]="tab.label | translate"
          (clicked)="setTab(tab.key)">
        </app-button>
      }

      <app-button class="vib-chart__report" variant="primary" size="small"
        [addIconLeft]="true"
        [state]="isDownloadingReport() ? 'disabled' : 'default'"
        [label]="'VIBRATION.REPORT' | translate"
        (clicked)="downloadRecordReport()">
        <img slot="icon-left" src="assets/icon/new_icon/report.svg" alt="" />
      </app-button>
    </div>
    <div class="vib-chart__pane" [class.vib-chart__pane--hidden]="selectedTab() !== 'signal'">
      @for (channel of channels(); track $index; let i = $index) {
        <div class="vib-chart__line">
          <div class="channel-card">
            <div class="channel-card__title">{{ 'VIBRATION.CHANNEL' | translate }} {{ i + 1 }}</div>
            <div class="channel-card__sub">{{ vibrationRecord()?.recordMetadata?.transducerAxis?.[i] | formatTransducerType }}</div>
            <div class="channel-card__sub">{{ vibrationRecord()?.recordMetadata?.transducerType?.[i] | formatTransducerType }}</div>
            <div class="channel-card__value">
              {{ 'VIBRATION.RAW' | translate }} :
              {{ findMaxAbsValue(channel.timeSpectrum.ppvMin, channel.timeSpectrum.ppvMax) | number:'1.2-2' }}
              {{ i < 3 ? 'mm/s' : 'Pa' }}
            </div>
          </div>

          <div class="vib-chart__canvas">
            <canvas [attr.id]="'canvas-' + i"></canvas>
          </div>
        </div>
      }
    </div>

    <div class="vib-chart__pane" [class.vib-chart__pane--hidden]="selectedTab() !== 'frequency'">
      <div class="vib-chart__line">
        <div class="vib-chart__cards">
          @for (channel of channels(); track $index; let i = $index) {
            @if (i < 3) {
              <div class="channel-card">
                <div class="channel-card__title">{{ 'VIBRATION.CHANNEL' | translate }} {{ i + 1 }}</div>
                <div class="channel-card__sub">{{ channelNames[i] | translate }}</div>
                <div class="channel-card__sub">
                  {{ 'VIBRATION.FFT_PEAK' | translate }} : {{ channel.frequencySpectrum.maximumFrequencyHz | number:'1.0-0' }} Hz
                </div>
              </div>
            }
          }
        </div>

        <div class="vib-chart__canvas vib-chart__canvas--fft">
          <canvas id="canvas-fft"></canvas>
        </div>
      </div>
    </div>

    <div class="vib-chart__pane" [class.vib-chart__pane--hidden]="selectedTab() !== 'standard'">
      <div class="vib-chart__standard-picker">
        <label class="vib-chart__label">{{ 'VIBRATION.STANDARD' | translate }}</label>
        <app-select
          [options]="standardOptions()"
          size="small"
          [ngModel]="selectedStandardCode()"
          [placeholder]="'VIBRATION.SELECT_STANDARD' | translate"
          (selectionChange)="onStandardSelected($event)">
        </app-select>
      </div>

      @if (standardGraphData()?.weightedPpvValues != null) {
        <div class="vib-chart__cards">
          @for (ppv of localRecord()?.timeSpectrumWeighted; track $index; let i = $index) {
            @if (i < 3) {
              <div class="channel-card">
                <div class="channel-card__title">{{ 'VIBRATION.CHANNEL' | translate }} {{ i + 1 }}</div>
                <div class="channel-card__sub">{{ localRecord()?.recordMetadata?.transducerAxis?.[i] | formatTransducerType }}</div>
                <div class="channel-card__sub">{{ localRecord()?.recordMetadata?.transducerType?.[i] | formatTransducerType }}</div>
                <div class="channel-card__value">
                  {{ 'VIBRATION.WEIGHTED' | translate }} : {{ abs(ppv.ppvMax) | number:'1.2-2' }} mm/s
                </div>
              </div>
            }
          }

          <div class="channel-card">
            <div class="channel-card__title">{{ 'VIBRATION.PPV_MAX' | translate }}</div>
            <div class="channel-card__value">{{ findPPVMax(localRecord()?.timeSpectrumWeighted) | number:'1.2-2' }} mm/s</div>
          </div>
        </div>
      }

      @if (standardGraphData() && standardGraphData()?.weightedPpvValues == null) {
        <div class="vib-chart__compliance">
          @if (standardGraphData()?.standardName) {
            <div class="vib-chart__compliance-title">{{ standardGraphData()?.standardName }}</div>
          }
          <canvas id="canvas-compliance"></canvas>
        </div>
      }
    </div>

  </div>
}
